import React from "react";
import styled from "styled-components";
import { Container } from "../../AlmeResponse/AlmeResponse.styles";
import { PlainIcon } from "../../AlmeUtilities/Icons/PlainIcon";
const BannerContainer = styled(Container) `
  justify-content: start;
`;
const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 5px;
`;
const ContentHeader = styled.div `
  font-size: 20px;
  font-weight: 300;
  line-height: 1.2;
  color: ${props => props.color || props.theme.button.background};
`;
const ContentBody = styled.div `
  margin-top: 5px;
`;
const AlmeLiveChatBannerTemplate = (props) => {
    return (React.createElement(BannerContainer, null,
        React.createElement(PlainIcon, { color: props.iconColor, size: 25, icon: props.icon }),
        React.createElement(ContentContainer, null,
            React.createElement(ContentHeader, { id: `alme-live-chat-banner-main-${props.responseRevision}`, color: props.mainTextColor }, props.mainText),
            React.createElement(ContentBody, { id: `alme-live-chat-banner-sub-${props.responseRevision}` }, props.subText))));
};
export default AlmeLiveChatBannerTemplate;
